<template>
    <div class="oa-product-sticky-bar">
        <div class="container">
            <div class="product-sticky__general">
                <div class="product-sticky__thumbnail">
                    <img :src="`${baseUrl}api/wp-content/uploads/${props.thumbnailStickyBar}`" alt="">
                </div>
                <div class="product-sticky__info">
                    <p class="product-title">{{ props?.titleStickyBar }}</p>

                    <div  v-if="!isRequestPrice" class="price-bar">
                        <Price v-if="priceInfo && priceInfo.price" :priceInfo="priceInfo" />
                    </div>
                </div>
            </div>
            <div v-if="isRequestPrice" class="product-sticky__addcart-form">
                <div class="product-sticky__addcart">
                    <NuxtLink class="single_add_to_cart_consultation consultation" :to="`${baseUrl}consultation/?utm_page=${baseUrl}product/${slug}`">REQUEST CONSULTATION</NuxtLink>
                    <div class="tinv-wraper woocommerce tinv-wishlist tinvwl-shortcode-add-to-cart tinvwl-woocommerce_after_add_to_cart_button" :data-tinvwl_product_id="productId">
                    <a role="button" tabindex="0" name="" aria-label="" class="tinvwl_add_to_wishlist_button tinvwl-icon-custom no-txt tinvwl-position-after" data-tinv-wl-list="[]" :data-tinv-wl-product="productId" data-tinv-wl-productvariation="0" data-tinv-wl-productvariations="[]" data-tinv-wl-producttype="simple" data-tinv-wl-action="addto"> </a>
                    <div class="tinv-wishlist-clear"></div>
                    <span class="kts-wishlist-tooltip">Add to wishlist and send to your friends</span>
                    <div class="tinvwl-tooltip"></div>
                    </div>
                </div>
            </div>
            <div v-else-if="(!isRequestPrice && hasShowEnquire && !hasShowAtc)" >

            </div>
            <div v-else class="product-sticky__addcart-form">
                <div class="product-sticky__availability">
                    <!-- <p class="stock in-stock">In Stock</p> -->
                    <div class="regular-price-bottom">
                        <p v-if="props.priceInfo?.sale_price !== null" class="price-html" dir="ltr">
                            <del v-if="priceInfo?.regular_price != '0' && Number(priceInfo?.sale_price) > 0 && Number(priceInfo?.regular_price) > Number(priceInfo?.sale_price)">
                                <span class="woocommerce-Price-amount amount 99" v-html="displayCustomPrice(priceInfo?.regular_price)"></span>
                            </del>
                        </p>
                    </div>
                </div>
                <div class="product-sticky__addcart">
                    <div class="single_add_to_cart" :class="{ disabled: isDisabled }">
                        <a href="#" class="single_add_to_cart_btn" :aria-disabled="isDisabled" :tabindex="isDisabled ? -1 : 0">
                            <span>Add To Cart</span>
                        </a>
                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><circle cx="12" cy="2" r="0" fill="currentColor"><animate attributeName="r" begin="0" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(45 12 12)"><animate attributeName="r" begin="0.125s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(90 12 12)"><animate attributeName="r" begin="0.25s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(135 12 12)"><animate attributeName="r" begin="0.375s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(180 12 12)"><animate attributeName="r" begin="0.5s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(225 12 12)"><animate attributeName="r" begin="0.625s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(270 12 12)"><animate attributeName="r" begin="0.75s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(315 12 12)"><animate attributeName="r" begin="0.875s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle></svg>
                        <p v-if="props.priceInfo?.sale_price !== null" class="price-html" dir="ltr">
                            <span class="w_price" v-if="priceInfo?.regular_price != '0'">
                                <span class="single-sale-percent" v-if="Number(priceInfo?.regular_price) > 0 && Number(priceInfo?.sale_price) > 0 && Number(priceInfo?.regular_price) > Number(priceInfo?.sale_price) && Math.round(100 - (Number(priceInfo?.sale_price) / Number(priceInfo?.regular_price) * 100)) >= 5">
                                    <span :data-pecent="`-${Math.round(100 - (Number(priceInfo?.sale_price) / Number(priceInfo?.regular_price) * 100))}%`"></span>
                                </span>
                                <ins v-if="Number(priceInfo?.sale_price) > 0 "><span class="woocommerce-Price-amount amount 44" v-html="displayCustomPrice(priceInfo?.sale_price)"></span></ins>
                                <ins v-else><span class="woocommerce-Price-amount amount" v-html="displayCustomPrice(priceInfo?.regular_price)"></span></ins>
                            </span>
                        </p>
                        <p v-else class="price-html" dir="ltr">
                            <span class="w_price" v-if="priceInfo?.regular_price != '0'">
                                <ins><span class="woocommerce-Price-amount amount" v-html="displayCustomPrice(priceInfo?.regular_price)"></span></ins>
                            </span>
                        </p>
                    </div>
                    <div class="tinv-wraper woocommerce tinv-wishlist tinvwl-shortcode-add-to-cart tinvwl-woocommerce_after_add_to_cart_button" :data-tinvwl_product_id="props.productId">
                    <a v-if="props.productId" @click="handleClickWishlist($event, props.productId)" :class="{ active: props.isActive }" role="button" tabindex="0" name="" aria-label="" class="tinvwl_add_to_wishlist_button tinvwl-icon-custom no-txt tinvwl-position-after" data-tinv-wl-list="[]" data-tinv-wl-product="555284" data-tinv-wl-productvariation="0" data-tinv-wl-productvariations="[]" data-tinv-wl-producttype="simple" data-tinv-wl-action="addto"> </a>
                    <div class="tinv-wishlist-clear"></div>
                    <span class="kts-wishlist-tooltip">Add to wishlist and send to your friends</span>
                    <div class="tinvwl-tooltip"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_stickybar.scss";
</style>

<script setup lang="ts">
    import Price from "~/components/Product/SingleProduct/Layouts/Price.vue";
    import { formatPriceSingleProduct } from "~/utils/formatPrice";
    import { displayCustomPrice } from "~/utils/displayPrice"
    import { useAddToCartState } from '~/composables/useAddToCartState';
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const route = useRoute();
    const slug = route.params.slug as string;
    const props = defineProps({
        priceInfo: {
            type: Object,
        },
        isButtonActive: {
            type: Boolean,
            default: true
        },
        isActive: {
            type: Boolean,
        },
        isStatusBundle: {
            type: Boolean,
        },
        thumbnailStickyBar: {
            type: String
        },
        titleStickyBar:{
            type: String
        },
        actButton: {
            type: Object,
            default: () => ({
                isRequestPrice: false,
                isEnquire: {}
            })
        },
        productId: {
            type: Number
        },

        type: String,
    });
    const { isDisabled } = useAddToCartState(props);
    const productID = computed(() => props.productId);
    const emit = defineEmits(['handleWishlist']);

    const handleClickWishlist = (event: any, product_id: Number) => {
        event.stopPropagation();
        event.preventDefault();
        emit('handleWishlist', product_id);
    }
    const actButton = computed(() => props.actButton);
    const isRequestPrice = computed(() => {
        if (actButton.value) {
            return actButton.value.isRequestPrice;
        }
        return false;
    });
    const hasShowAtc = computed(() => actButton.value?.isEnquire ? Object.values(actButton.value.isEnquire).includes('show_atc') : false);
    const hasShowEnquire = computed(() => actButton.value?.isEnquire ? Object.values(actButton.value.isEnquire).includes('show_enquire') : false);
    const formattedPrices = computed(() =>
        formatPriceSingleProduct({
            salePrice: props.priceInfo?.sale_price,
            regularPrice: props.priceInfo?.regular_price ?? 0,
            salePercent: props.priceInfo?.sale_percent,
            currency: props.priceInfo?.currency ?? "USD",
        })
    );
    onMounted(() =>  {
        document.addEventListener('scroll',  (event) => {
            const stickyBar = document.querySelector('.oa-product-sticky-bar');
            if (!stickyBar) return;

            const addToCartButton = document.querySelector('.single_add_to_cart_button');
            const addToCartConsultation = document.querySelector('.single_add_to_cart_consultation');

            var enquiryButton = document.querySelector('.enquiry-btn-single');
            if (document.querySelector('.request_price_product')){
                enquiryButton = document.querySelector('.request_price_product .is-main-btn.enquiry-btn-single');
            }

            let isInViewport;
            let _documentHeight = document.body.scrollHeight;
            let scrollPosY = window.pageYOffset || document.body.scrollTop;
            let scrollHeight = (_documentHeight / 100) * 10; // Getting 10% of the total page height
            let footerHeight = document.documentElement.clientHeight;
            let scrollPixelsHide = 10;

        if (window.innerWidth < 769){
            const regularPrice = document.querySelector(".summary.entry-summary > .price .w_price del");
            const stickyRegularPrice = document.querySelector(".oa-product-sticky-bar .regular-price-bottom .price .w_price del");
            if (regularPrice && stickyRegularPrice){
                stickyRegularPrice.innerHTML = regularPrice.innerHTML;
            }
        }
            //first before parent or for both position on scroll
            // Function to check if element is in viewport
            function isVisible (ele: any) {
                const { top, bottom } = ele.getBoundingClientRect();
                const vHeight = (window.innerHeight || document.documentElement.clientHeight);

                return (
                    (top > 0 || bottom > 0) &&
                    top < vHeight
                );
            }

            if (addToCartButton) {
                isInViewport = isVisible(addToCartButton);
            } else if (enquiryButton) {
                isInViewport = isVisible(enquiryButton);
            } else if(addToCartConsultation){
                isInViewport = isVisible(addToCartConsultation);
            }

            const customise = document.querySelector('.main_product.main_product--customise')

            if(customise){
                const shippingElement:any = document.querySelector('.single-product__shipping')
                const shippingPosition = shippingElement.getBoundingClientRect()

                if (shippingPosition.top < 150 ) {

                    stickyBar.classList.add('active');

                } else {

                    stickyBar.classList.remove('active');

                }

            }else {
                const btnAddToCartElement:any = document.querySelector('.btn-single-atc.single_add_to_cart_button')
                if (btnAddToCartElement ) { 
                    const addToCartPosition = btnAddToCartElement.getBoundingClientRect();

                    if (addToCartPosition.top < 10) {
                        if (!stickyBar.classList.contains('active')) {
                            stickyBar.classList.add('active');
                        }
                    } else {
                        if (stickyBar.classList.contains('active')) {
                            stickyBar.classList.remove('active');
                        }
                    }
                }

                // console.log('11111111');
                // if ( scrollPosY >  (scrollPixelsHide || scrollHeight)   ||
                // ( scrollPosY <= ( _documentHeight - window.innerHeight ) && 'bottom' == "bottom" ) || isInViewport==true) {
                //     stickyBar.classList.add('active');
                // }

                // // If position top then before 10px stroll op hide sticky bar.
                // if( ( scrollPosY < ( scrollPixelsHide || 10 ) ) ) {
                //     stickyBar.classList.remove('active');
                // }

                // if (( scrollPosY >= ( _documentHeight - window.innerHeight ) ||  (scrollPosY <= (scrollPixelsHide || 0) &&  scrollPixelsHide ) )
                //     && 'bottom' == "bottom" ) {
                //     stickyBar.classList.remove('active')
                // }

                // if (isInViewport) {
                //     stickyBar.classList.remove('active');
                // } else {
                //     stickyBar.classList.add('active');
                // }


            }

        })
    })
</script>
